import { useCallback, useContext, useState } from 'react'

import { useSelector } from 'react-redux'
import { faPlus } from '@fortawesome/pro-solid-svg-icons'
import { isFunction } from 'lodash'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { InternshipFormModalContext, Types } from '../../../../Providers/Forms/InternshipForm/InternshipFormModal'
import DisplacementDatePicker from '../../../../Components/institution/Quotas/shared/DisplacementDatePicker'
import PlacesOccupancyTablesSettings from './PlacesOccupancyTablesSettings'
import IconButton from '../../../../Components/antd/Buttons/IconButton'
import { firstOrDefault, getIdOrNull } from '../../../../utils'
import { Internship, Ownership } from '../../../../utils/entities/internship'
import { selectUser } from '../../../../reducers/UserReducer'

const PlacesOccupancyHeader = ({
  addDisabled, period, isYearly, overlaySettings, school, isHostpitalDepartmentViewToggled,
  onPeriodChange, onDateChange, onOverlaySettingsSelection, onInternshipChange, onIsYearlyChange, onHospitalDepartmentViewToggled, onResetGravity
}) => {
  const { setFormHandler } = useContext(InternshipFormModalContext)

  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [isSettingsVisible, setIsSettingsVisible] = useState(false)
  const [isOverlayMenuVisible, setIsOverlayMenuVisible] = useState(false)

  const hideOverlayMenuAndDo = useCallback(callback => isVisible => {
    if (isFunction(callback)) {
      callback(isVisible)
    }
    if (isOverlayMenuVisible) {
      setIsOverlayMenuVisible(false)
    }
  }, [isOverlayMenuVisible])

  const handleAddClick = useCallback(internship => {
    setFormHandler({
      data: new Internship({
        ...internship,
        startDate: period?.startDate,
        endDate: period?.endDate,
        institution: firstOrDefault(user.institutions),
        school: getIdOrNull(school),
        ownership: Ownership.INSTITUTION
      }),
      callback: onInternshipChange,
      type: Types.BULK
    })
  }, [setFormHandler, period, school, user.institutions, onInternshipChange])

  return (
    <div className='places-occupancy-header flex-row mb-8'>
      <IconButton
        key='settings'
        icon={faPlus}
        disabled={addDisabled}
        text={t('quota_table_menu.buttons.add_quota')}
        onClick={handleAddClick}
      />

      <div className='h-spacing' />

      <PlacesOccupancyTablesSettings
        overlayPrefix='places_occupancy_view.overlay_option.'
        visible={isSettingsVisible}
        period={period}
        isYearly={isYearly}
        overlaySettings={overlaySettings}
        overlayMenuVisible={isOverlayMenuVisible}
        isHostpitalDepartmentViewToggled={isHostpitalDepartmentViewToggled}
        onClick={setIsSettingsVisible}
        onVisibleChange={hideOverlayMenuAndDo(setIsSettingsVisible)}
        onPeriodChange={onPeriodChange}
        onIsYealyChange={onIsYearlyChange}
        onOverlaySettingsSelection={onOverlaySettingsSelection}
        onOverlayMenuVisibleChange={setIsOverlayMenuVisible}
        onHospitalDepartmentViewToggled={onHospitalDepartmentViewToggled}
        onResetGravity={onResetGravity}
      />

      <div className='flex-fill' />

      <DisplacementDatePicker
        date={period.startDate}
        timePeriod={period.type}
        onDateChange={onDateChange}
      />
    </div>
  )
}

export default PlacesOccupancyHeader
